var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pattern-wrapper" },
    [
      !_setup.isPattern
        ? [
            _c(_setup.CButton, {
              attrs: {
                variant: "secondary",
                text: "Create Pattern from Element",
              },
              on: {
                click: function ($event) {
                  return _setup.emit("create-pattern")
                },
              },
            }),
          ]
        : [
            _c("div", { staticClass: "section-title" }, [_vm._v("Spacing")]),
            _vm._v(" "),
            _c("hr", { staticClass: "section-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c(_setup.CInput, {
                    attrs: {
                      value: _setup.model.spacingX,
                      type: "number",
                      label: "Horizontal (%)",
                      step: 1,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onConfigInput("spacingX", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c(_setup.CInput, {
                    attrs: {
                      value: _setup.model.spacingY,
                      type: "number",
                      label: "Vertical (%)",
                      step: 1,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onConfigInput("spacingY", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-title" }, [_vm._v("Offset")]),
            _vm._v(" "),
            _c("hr", { staticClass: "section-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c(_setup.CInput, {
                    attrs: {
                      value: _setup.model.offsetX,
                      type: "number",
                      label: "Horizontal (%)",
                      step: 1,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onConfigInput("offsetX", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c(_setup.CInput, {
                    attrs: {
                      value: _setup.model.offsetY,
                      type: "number",
                      label: "Vertical (%)",
                      step: 1,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.onConfigInput("offsetY", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pattern-actions" },
              [
                _c(_setup.CButton, {
                  staticClass: "w-50",
                  attrs: {
                    variant: "secondary",
                    text: "Refresh to Fill Page",
                    icon: ["far", "arrow-rotate-left"],
                  },
                  on: {
                    click: function ($event) {
                      return _setup.emit("refresh-fill")
                    },
                  },
                }),
                _vm._v(" "),
                _c(_setup.CButton, {
                  staticClass: "w-50",
                  attrs: {
                    variant: "secondary",
                    text: "Remove",
                    icon: ["far", "trash"],
                  },
                  on: {
                    click: function ($event) {
                      return _setup.emit("remove-pattern")
                    },
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }